import {Map} from 'immutable'
import {SubmissionError} from "redux-form"
import {INFO, INFO_TYPE_ERROR, INFO_TYPE_INFO, showModal} from "../modules/modals"


export const getRandomId = () => (Date.now() + Math.random()).toString()

export const arrayToMap = (arr, ItemRecord, idKey = 'id') => {
    let res = arr.reduce(function (acc, item) {
        return acc.set(item[idKey], ItemRecord ? new ItemRecord(item) : item);
    }, new Map({}));
    return res;
}

export const arrayToMapOptimizer = (params) => {
    let {arr, ItemRecord, idKey = 'id', optimizer} = params;
    let res = arr.reduce(function (acc, item) {
        if (optimizer) item = optimizer(item)
        return acc.set(item[idKey], ItemRecord ? new ItemRecord(item) : item);
    }, new Map({}));
    return res;
}

export const arrayPrimitivesToMap = (arr, initObj = {}) => arr.reduce((res,curr)=>res.set(curr, 1), new Map(initObj))

export let arrayUnique = (array) => Array.from(new Set(array))

export let arrayRange = (count, start = 0) => Array(10).fill().map((x,i)=>i + start)

export const sortCB = ({id : aId, created_at : aCreated_at}, {created_at : bCreated_at, id : bId}) => aCreated_at !== bCreated_at ? aCreated_at - bCreated_at : aId - bId
export const updateSortCB = ({updated_at : aUpdated_at}, {updated_at : bUpdated_at}) => aUpdated_at - bUpdated_at

export const getSortStringCB = (key = 'name') => (a, b) => a[key].localeCompare(b[key])

/**
 * Get YouTube ID from various YouTube URL
 * @author: takien
 * @url: http://takien.com
 * For PHP YouTube parser, go here http://takien.com/864
 */
export const youTubeGetID = (url) => {
    var ID = '';
    url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if(url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
    }
    else {
        ID = url;
    }
    return ID;
}

/**
* https://stackoverflow.com/a/38935990
* */
export const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${__getFormatFromMime(mime)}`, {type:mime});
}

const __getFormatFromMime = mime => {
    if (!mime) return ""
    const _split = mime.split('/')
    const format = _split[1]
    return format === 'jpeg' ? "jpg" : format // for some reason server not save files with .jpeg name
}

/**
* https://stackoverflow.com/a/26230989
* */
export const getCoords = (elem) => { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top  = box.top +  scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
}

export const formatErrorMessage = (message, defaultMsg = "Something went wrong") => {
    let formatted = _formatErrorMessage(message)
    if (!formatted) formatted = defaultMsg
    return formatted
}
const _formatErrorMessage = message => {
    switch (true) {
        case typeof message === 'string' : {
            return message
            break
        }
        case Array.isArray(message) : {
            return message.join(", ")
            break
        }
        case ((typeof message === 'object') && !!Object.values(message).length) : {
            let formatted = ""
            for (let key in message) {
                formatted += `${_formatErrorMessage(message[key])} `
            }
            return formatted
            break
        }
        default : {
            return ""
            break
        }
    }
}

/*
* https://stackoverflow.com/a/3820412
* */
export const baseName = path => {
    let base = ("" + path).substring(path.lastIndexOf('/') + 1)
    if(base.lastIndexOf(".") != -1) base = base.substring(0, base.lastIndexOf("."))
    return base;
}


export const capitalizeFirstLetter = (string) => { /*https://stackoverflow.com/a/1026087*/
    return string.charAt(0).toUpperCase() + string.slice(1);
}


/*
* https://codepen.io/jelmerdemaat/pen/brjKG
* */
export const downloadFile = (url) => {
    //iOS devices do not support downloading. We have to inform user about this.
    if (/(iP)/g.test(navigator.userAgent)) {
        alert('Your device does not support files downloading. Please try again in desktop browser.');
        window.open(url, '_blank');
        return false;
    }

    //If in Chrome or Safari - download via virtual link click
    if (isChrome() || isSafari()) {
        //Creating new link node.
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('target','_blank');

        if (link.download !== undefined) {
            //Set HTML5 download attribute. This will prevent file from opening if supported.
            let fileName = url.substring(url.lastIndexOf('/') + 1, url.length);
            link.download = fileName;
        }

        //Dispatching click event.
        if (document.createEvent) {
            let e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
            return true;
        }
    }

    // Force file download (whether supported by server).
    if (url.indexOf('?') === -1) {
        url += '?download';
    }

    window.open(url, '_blank');
    return true;
}

export const isChrome = () => navigator.userAgent.toLowerCase().indexOf('chrome') > -1
export const isSafari = () => navigator.userAgent.toLowerCase().indexOf('safari') > -1


export function throttle (func, ms) {

    let isThrottled = false;
    let savedArgs
    let savedThis

    function wrapper() {

        if (isThrottled) {
            savedArgs = arguments
            savedThis = this
            return
        }

        func.apply(this, arguments)

        isThrottled = true

        setTimeout(function() {
            isThrottled = false
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs)
                savedArgs = savedThis = null
            }
        }, ms)
    }

    return wrapper
}

export const middleThen = response => {
    if (response.status >= 400) throw new Error(response.statusText)
    return response.json()
}

export const middleReduxFormThen = response => {
    if (response.status >= 400) throw new SubmissionError({
        _error : formatErrorMessage(response.statusText),
    })
    return response.json()
}

export const successModalThen = ({message, dispatch}) => (response) => {
    if (response && response.skipSuccess) return
    dispatch(showModal({
        modalType : INFO,
        modalProps : {
            title : "Success",
            text : message,
            infoType : INFO_TYPE_INFO,
        }
    }))
}

export const errorModalCatch = ({dispatch}) => error => {
    dispatch(showModal({
        modalType : INFO,
        modalProps : {
            title : "Fail",
            text : (error.message ? error.message : error + ""),
            infoType : INFO_TYPE_ERROR,
        }
    }))
}


export const findVal = (object, key) => {
    let value
    Object.keys(object).some(function(k) {
        if (k === key) {
            value = object[k]
            return true
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findVal(object[k], key)
            return value !== undefined
        }
    })
    return value
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/common.js